export default {
  /**
   * 每个插件都有的install方法，用于安装插件
   * @param {Object} Vue - Vue类
   * @param {Object} [pluginOptions] - 插件安装配置
   */
  // eslint-disable-next-line no-unused-vars
  install(Vue, pluginOptions = {}) {
    // 创建"子类"方便挂载
    // 浏览器
    let browser = {};
    browser = {
      // 主要浏览器
      ie: 0,
      firefox: 0,
      safari: 0,
      konq: 0,
      opera: 0,
      chrome: 0,
      wx: 0,
      wxpc: 0,
      wxworkpc: 0, //只支持pc端企业微信
      pc: 0, //pc：支持pc端企业微信和微信
      // 具体的版本号
      ver: null,
    };
    try {
      // 检测呈现引擎和浏览器
      var ua = navigator.userAgent;
      // 微信检查
      // eslint-disable-next-line no-useless-escape
      if (/MicroMessenger\/([\d\.]+)/i.test(ua)) {
        browser.ver = RegExp["$1"];
        browser.wx = 1;
        browser.wxpc = /WindowsWechat/i.test(ua); //只支持window
        browser.wxworkpc = /Wechat/i.test(ua) && /wxwork/i.test(ua); //window、mac只支持企业微信
        browser.pc = /Wechat/i.test(ua); //支持window 微信 企业微信 mac 企业微信
      }

      // 兼容抖音代码，暂时不处理
      // var isTTWebView = ua.toLowerCase().includes("toutiaomicroapp");

      // if(isTTWebView) {
      //   browser.wx = 2;
      // }

    } catch (ex) {
      console.log("browser获取异常---", JSON.stringify(ex));
    }
    // 返回对象
    Vue.browser = Vue.prototype.browser = browser;
  },
};
